import styled from 'styled-components'
import { PanelBody } from '../Panel/Panel'

import { breakpoint } from 'utils'
import Box, { Text, BoxProps } from 'components/Box'

export const Row = styled.section`
  display: flex;
  flex-direction: column;

  ${breakpoint('sm')`
    flex-direction: row;
  `}

  padding: 12px 0;
  border-radius: ${({ theme }) => theme.radii.large};

  ${PanelBody} &:nth-of-type(odd) {
    background-color: ${({ theme }) => theme.colors.background.secondary[2]};
  }
`

export const Header = styled(Text.H1)<BoxProps>`
  display: flex;
  padding-left: 12px;

  margin: 0;
  flex-shrink: 0;

  font-size: ${({ theme }) => theme.fontSizes.small};
  font-weight: 400;
  line-height: 1.4;

  color: ${({ theme }) => theme.colors.foreground.secondary[4]};
`
Header.defaultProps = { width: '200px' }

export const Cell = styled(Box)<BoxProps>`
  display: flex;
  flex: 1;

  padding-left: 12px;

  font-size: ${({ theme }) => theme.fontSizes.smaller};
  font-weight: 400;
  line-height: 1.5;

  color: ${({ theme }) => theme.colors.foreground.secondary[4]};

  b,
  strong {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.foreground.secondary[1]};
  }

  :last-child {
    padding-right: 12px;
  }

  &.action {
    flex: 0;

    a:not([class]) {
      text-decoration: underline;
    }
  }

  ${Header} + &, & + & {
    margin-top: 8px;
    ${breakpoint('sm')`
       margin-top: 0;
    `}
  }
`
Cell.defaultProps = { width: '200px' }
